import { EventsPagePastEventsSection, EventsPageSearchWidget, EventsPageUpcomingEventsSection } from "./__components";
import { useEffect, useState } from "react";
import { events_helper } from "@/helpers/events_helper";

export const EventsPageContentSection = () => {
  const [tag, setTag] = useState("");
  const [query, setQuery] = useState("");
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 500);

    setUpcomingEvents(events_helper.fetchUpcomingEvents({ tag, query }));
    setPastEvents(events_helper.fetchPastEvents({ tag, query }));

    return () => {
      clearTimeout(timeout);
    };
  }, [tag, query]);

  const onSubmit = ({ tag, query }) => {
    setTag(tag);
    setQuery(query);
  };

  return (
    <>
      <EventsPageSearchWidget onSubmit={onSubmit} />
      <EventsPageUpcomingEventsSection events={upcomingEvents} loading={loading} />
      <EventsPagePastEventsSection events={pastEvents} loading={loading} />
    </>
  );
};
